export const getLanguedocRoussillonData = () => ({
  name: "Languedoc-Roussillon",
  country: "France",
  description: "Le Languedoc-Roussillon est la plus grande région viticole française, s'étendant de la Camargue aux Pyrénées. Cette région méditerranéenne produit une incroyable diversité de vins, des vins de table aux vins d'appellation d'origine contrôlée de qualité.",
  type: "region",
  mapAreas: [
    { region: "Languedoc-Roussillon", x: 50, y: 80, color: "#4B164C", size: 9 }
  ],
  statistics: {
    totalArea: "240,000 ha",
    production: "13 million hectolitres",
    appellations: "36 appellations",
    departments: "4 départements",
    exportPercentage: "25%"
  },
  characteristics: {
    climate: "Climat méditerranéen chaud et sec avec influence maritime",
    soil: "Sols très variés : calcaire, argile, schiste, galets roulés",
    viticulture: "Viticulture moderne et traditionnelle, respect de l'environnement"
  },
  wineStyles: {
    red: "Vins rouges fruités et équilibrés, du léger au puissant",
    white: "Vins blancs secs et aromatiques, frais et complexes",
    rose: "Rosés fruités et équilibrés, parfaits pour l'apéritif",
    sparkling: "Crémants de Limoux, vins effervescents de qualité",
    sweet: "Vins doux naturels, concentrés et complexes"
  },
  history: "La viticulture dans le Languedoc-Roussillon remonte à l'époque romaine. Au Moyen Âge, les monastères ont développé la viticulture. Le XIXe siècle a vu l'expansion massive du vignoble. Aujourd'hui, la région se modernise et produit des vins de qualité.",
  foodPairing: "Cuisine méditerranéenne, fruits de mer, viandes grillées, fromages, tapas",
  subregions: {
    "corbieres": {
      name: "Corbières",
      description: "Région montagneuse produisant des vins rouges puissants et structurés, avec une forte identité terroir.",
      characteristics: {
        climate: "Climat méditerranéen avec influence montagneuse",
        soil: "Sols de schiste, calcaire et argile",
        viticulture: "Viticulture traditionnelle, vendanges manuelles"
      },
      grapeVarieties: {
        red: ["Carignan", "Grenache", "Syrah", "Mourvèdre"],
        white: ["Grenache Blanc", "Clairette", "Bourboulenc"]
      },
      wineStyles: {
        "corbieres-rouge": "Vins rouges puissants et structurés",
        "corbieres-blanc": "Vins blancs secs et aromatiques",
        "corbieres-rose": "Rosés fruités et équilibrés"
      },
      foodPairing: "Viandes rouges, gibier, fromages affinés, cuisine du sud"
    },
    "minervois": {
      name: "Minervois",
      description: "Région de coteaux produisant des vins rouges élégants et des vins blancs aromatiques de qualité.",
      characteristics: {
        climate: "Climat méditerranéen tempéré",
        soil: "Sols de calcaire, argile et schiste",
        viticulture: "Viticulture traditionnelle, rendements limités"
      },
      grapeVarieties: {
        red: ["Syrah", "Grenache", "Carignan", "Mourvèdre"],
        white: ["Grenache Blanc", "Clairette", "Roussanne"]
      },
      wineStyles: {
        "minervois-rouge": "Vins rouges élégants et fruités",
        "minervois-blanc": "Vins blancs secs et aromatiques",
        "minervois-rose": "Rosés frais et fruités"
      },
      foodPairing: "Viandes blanches, poissons, fromages, cuisine méditerranéenne"
    },
    "fitou": {
      name: "Fitou",
      description: "Région côtière produisant des vins rouges puissants et tanniques, avec une forte identité maritime.",
      characteristics: {
        climate: "Climat méditerranéen avec influence maritime",
        soil: "Sols de schiste, calcaire et argile",
        viticulture: "Viticulture traditionnelle, vendanges manuelles"
      },
      grapeVarieties: {
        red: ["Carignan", "Grenache", "Syrah", "Mourvèdre"]
      },
      wineStyles: {
        "fitou-rouge": "Vins rouges puissants et tanniques",
        "fitou-vieillissement": "Vins de garde, complexes et structurés"
      },
      foodPairing: "Viandes rouges, gibier, fromages affinés, cuisine du sud"
    },
    "limoux": {
      name: "Limoux",
      description: "Région montagneuse produisant des vins effervescents de qualité et des vins blancs aromatiques.",
      characteristics: {
        climate: "Climat méditerranéen avec influence montagneuse",
        soil: "Sols de calcaire et argile",
        viticulture: "Viticulture traditionnelle, méthode traditionnelle"
      },
      grapeVarieties: {
        white: ["Chardonnay", "Chenin Blanc", "Mauzac"],
        red: ["Pinot Noir", "Merlot", "Cabernet Sauvignon"]
      },
      wineStyles: {
        "cremant-de-limoux": "Vins effervescents de qualité",
        "limoux-blanc": "Vins blancs secs et aromatiques",
        "limoux-rouge": "Vins rouges fruités et élégants"
      },
      foodPairing: "Apéritifs, poissons, volailles, fromages, cuisine légère"
    }
  }
}); 